exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".formCardDash[data-v-ab901648]{border-radius:8px;box-shadow:0 2px 4px rgba(0,0,0,.1)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ab901648","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/dashboard/salesPersonDashboard/ConsoleBookingSection.vue
// module id = 1777
// module chunks = 0